import { render, staticRenderFns } from "./AdvancedSettingsPanels.vue?vue&type=template&id=58fc3804&lang=pug&"
import script from "./AdvancedSettingsPanels.vue?vue&type=script&lang=js&"
export * from "./AdvancedSettingsPanels.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedSettingsPanels.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports